import React, { memo } from 'react'

import { useTranslation } from 'react-i18next'
import { GroupBase, StylesConfig } from 'react-select'
import CreatableSelect, { CreatableProps } from 'react-select/creatable'

import { isNil } from '@/helpers/type-guards'
import { SelectOption } from '@/models/common'

import { getCustomSelectStyle } from './atoms'

interface OwnProps<OptionType extends SelectOption, IsMulti extends boolean, Group extends GroupBase<OptionType>> {
  hasError?: boolean
  customStyle?: StylesConfig<OptionType, IsMulti, Group>
  menuHeight?: number
}

const components = {
  DropdownIndicator: null,
}

const SelectComponent = <
  OptionType extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<OptionType> = GroupBase<OptionType>,
>({
  value,
  name,
  placeholder,
  hasError,
  customStyle,
  menuHeight,
  isMulti,
  isDisabled,
  inputValue,
  options,
  ...rest
}: OwnProps<OptionType, IsMulti, Group> & CreatableProps<OptionType, IsMulti, Group>) => {
  const { t } = useTranslation()
  const handleFormat = (value: string) => t('creatable.create_option', { name: value })

  return (
    <CreatableSelect
      value={value}
      name={name}
      isClearable
      openMenuOnClick={!isNil(options)}
      placeholder={placeholder}
      components={components}
      isMulti={isMulti}
      isDisabled={isDisabled}
      inputValue={inputValue}
      styles={customStyle || getCustomSelectStyle({ hasError, menuHeight })}
      classNamePrefix="react-select"
      formatCreateLabel={handleFormat}
      options={options}
      {...rest}
    />
  )
}

export default memo(SelectComponent)
